import { render, staticRenderFns } from "./SelectColor.vue?vue&type=template&id=eed8f120&scoped=true"
import script from "./SelectColor.vue?vue&type=script&lang=js"
export * from "./SelectColor.vue?vue&type=script&lang=js"
import style0 from "./SelectColor.vue?vue&type=style&index=0&id=eed8f120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed8f120",
  null
  
)

export default component.exports